

( function () {
   
    'use strict';

    ( function ( $ ) {
        $('.text-image-slider').slick({
            dots:false,
            infinite: true,
            speed: 900,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay:true,
            autoplaySpeed: 2000,
            arrows:true,
            responsive: [
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow:3,
                    slidesToScroll:1,
                    infinite: true,
                }
            },
            {
                breakpoint:767,
                settings: {
                    slidesToShow:1,
                    slidesToScroll:1,
                    centerPadding: '60px',
                    centerMode: true,
                }
            }
            ]
        });
             
        
    } )( jQuery );
} )();

